import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import PageHead from "@components/Components/Reusables/PageHead";
import dynamic from "next/dynamic";
import { handleRateLimit } from "utils/handleRateLimit";

const Home = dynamic(() => import("../js/Components/HomeComponent/Home"), {
    ssr: true,
});
const EHHome = dynamic(() => import("../js/Components/HomeComponent/EH/Home"), {
    ssr: true,
});


//Dynamically load the home component and return it
const index = ({ data }) => {
    const template_page_content = data.template_page_content ?? null;
    if (process.env.brand.acronym == 'EH') return <PageContextWrapper page='home' page_content={template_page_content}><EHHome homeData={data} /></PageContextWrapper>

    return (
        <>
            {/*         
            <Head>
                <title>{global_settings.site_name}</title>
                <meta
                    name="description"
                    content={global_settings.site_description}
                />
                <meta name="keywords" content="Furniture Hire London" />
            </Head> */}
            <PageContextWrapper page='home' page_content={template_page_content}>
                <PageHead
                    ogTitle={template_page_content.meta.og_title}
                    ogType={template_page_content.meta.og_type}
                    ogUrl={template_page_content.meta.og_url}
                    ogImage={template_page_content.meta.og_image}
                    ogDescription={template_page_content.meta.og_description}
                    ogSiteName={template_page_content.meta.og_site_name}
                />
                <Home homeData={data} />
            </PageContextWrapper>
        </>
    );
};

export async function getServerSideProps({ query, res, req }) {

    try {

        const request = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-home-content`);
        let data = await request.json();



        const rateLimitRedirect = handleRateLimit(res, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (data.exception) {
            return { notFound: true }
        }

        res.setHeader(
            'Cache-Control',
            'public, s-maxage=43200, stale-while-revalidate=59'
        )

        // Pass data to the page via props
        return {
            props: { data },
        };
    } catch (error) {
        return {
            props: {
                error: true,
                statusCode: 500

            }
        }

    }
}

export default index;
